import api from "../axios";
import { type Order, type OrderPrice, type OrderDetails } from "../types";

interface CreateOrderPayload {
  customer_email: string;
  tariff_id: number;
  services: {
    service_type: "auto_table" | "auto_jam";
    service_id: string;
  }[];
  save_payment_method: boolean;
  start_subscription: boolean;
  promocode_code: string | null;
  saved_payment_method_id: string | null;
}

export const createOrder = async (data: CreateOrderPayload) => {
  const response = await api.post<Order>("/orders", data);
  return response.data;
};

export const getOrderDetails = async (orderId: string) => {
  const response = await api.get<OrderDetails>(`/orders/${orderId}`);
  return response.data;
};

export const getOrderPrice = async (data: {
  tariff_id: number;
  promocode_code?: string;
  service_type?: "auto_table" | "auto_jam";
  service_id?: string;
}) => {
  const params = new URLSearchParams(data as unknown as Record<string, string>);
  const response = await api.get<OrderPrice>(
    `/orders/price?${params.toString()}`,
  );
  return response.data;
};
